/*function formatTwoDigit(n) {
    return n > 10 ? n : "0" + n;
}*/

export function EventInstance() {
    /*const nowDate = new Date();
    let mm = formatTwoDigit(nowDate.getMonth() + 1);
    let dd = formatTwoDigit(nowDate.getDate());
    let hh = formatTwoDigit(nowDate.getHours());
    let min = formatTwoDigit(nowDate.getMinutes());
    let formattedDate = nowDate.getFullYear() + '-' + mm + '-' + dd + 'T' + hh + ':' + min;*/

    return {
        id: -1,
        title: "",
        description: "",
        startdatetime: "",
        enddatetime: "",
        location: {
            state: "Italia",
            city: "",
            address: "",
            place: ""
        },
        posterurl: "",
        pricetype:"0",
        price: "",
        fb_link: "",
        external_link: "",
        zoomposter: false
    }
}


// WEBPACK FOOTER //
// ./src/models/index.js